module.exports = __webpack_public_path__ + "md.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/md.svg
// module id = 934
// module chunks = 0